import baseAPI from '@/api/base';
import { EditDepartment, GetDepartment, RegisterDepartment } from '@/dtos/department.dto';
import {
  DELETE_DEPARTMENT_URL,
  EDIT_DEPARTMENT_URL,
  GET_DEPARTMENT_URL,
  GET_ORGANIZATIONAL_DEPARTMENT_URL,
  REGISTER_DEPARTMENT_URL,
  TOGGLE_DEPARTMENT_IS_ACTIVE_URL,
  GET_DEPARTMENT_IMPACT_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Department {
  static getDepartments = async (getDepartment: GetDepartment): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_DEPARTMENT_URL, {
      params: getDepartment,
    });
    return response;
  };

  static getOrganizationalDepartments = async (getDepartment: GetDepartment): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ORGANIZATIONAL_DEPARTMENT_URL, {
      params: getDepartment,
    });
    return response;
  };

  static registerDepartment = async (
    registerDepartment: RegisterDepartment
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_DEPARTMENT_URL, {
      ...registerDepartment,
    });
    return response;
  };

  static editDepartment = async (editDepartment: EditDepartment): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_DEPARTMENT_URL, {
      ...editDepartment,
    });
    return response;
  };

  static toggleDepartmentIsActive = async (
    editDepartment: EditDepartment
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_DEPARTMENT_IS_ACTIVE_URL,
      {
        ...editDepartment,
      }
    );
    return response;
  };

  static getDepartmentImpact = async (params: { id: string }): Promise<AxiosResponse> => {
    return baseAPI.get(GET_DEPARTMENT_IMPACT_URL, { params });
  };

  static deleteDepartment = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_DEPARTMENT_URL}/${userId}`
    );
    return response;
  };
}

export default Department;
